import type { ReactNode } from "react";
import { useT } from "@/contexts/I18nContext";

/**
 * What a table shows before anyone has done anything.
 *
 * Always says what to do next. An empty grid with the word "None" tells a
 * teacher that the product is working and gives them nowhere to go.
 */
export function EmptyState({
  titleKey,
  bodyKey,
  action,
}: {
  titleKey: string;
  bodyKey?: string;
  action?: ReactNode;
}) {
  const t = useT();
  return (
    <div className="py-16 text-center">
      {/*
        A heading, not a paragraph. An empty state is the only thing on the
        screen, and somebody navigating by headings should be able to find out
        what they are looking at.
      */}
      <h2 className="section-title">{t(titleKey)}</h2>
      {bodyKey ? <p className="mx-auto mt-2 max-w-md text-[14px] text-ink-muted">{t(bodyKey)}</p> : null}
      {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
    </div>
  );
}
